// // UPDATING AACTUQL CODE

// import {
//   Button,
//   Divider,
//   FormControl,
//   FormControlLabel,
//   FormLabel,
//   Radio,
//   RadioGroup,
// } from "@mui/material";
// import React, { useState } from "react";
// import { brands } from "../../../data/Filter/brand";
// import { teal } from "@mui/material/colors";
// import zIndex from "@mui/material/styles/zIndex";
// import { size } from "../../../data/Filter/size";
// import { colors } from "../../../data/Filter/color";
// import { price } from "../../../data/Filter/price";
// import { discount } from "../../../data/Filter/discount";
// import { useSearchParams } from "react-router-dom";

// const FilterSection = () => {
//   const [expendColor, setExpendColor] = useState(false);
//   const [expendBrand, setExpendBrand] = useState(false);
//   const [expendSize, setExpendSize] = useState(false);

//   const [searchParams, setSearchParams] = useSearchParams();

//   const handleExpendBrand = () => {
//     setExpendBrand(!expendBrand);
//   };
//   const handleExpendColor = () => {
//     setExpendColor(!expendColor);
//   };

//   const handleExpendSize = () => {
//     setExpendColor(!expendColor);
//   };

//   const updateFilterParams = (e: any) => {
//     const { value, name } = e.target;
//     if (value) {
//       searchParams.set(name, value);
//     } else {
//       searchParams.delete(name);
//     }
//     setSearchParams(searchParams);
//   };

//   const clearAllFilters = () => {
//     console.log("clearAllFilters",searchParams)
//     searchParams.forEach((value: any, key: any) => {
//       searchParams.delete(key);
//     });
//     setSearchParams(searchParams);
//   };

//   return (
//     <div className="-z-50 space-y-5 bg-white">
//       <div className="flex items-center justify-between h-[40px] px-9 lg:border-r">
//         <p className="text-lg font-semibold">Filters</p>
//         <Button
//         onClick={clearAllFilters}
//           size="small"
//           className="text-teal-600 cursor-pointer font-semibold"
//         >
//           clear all
//         </Button>
//       </div>
//       <Divider />
//       <div className="px-9 space-y-6">
//         {/* <section>
//           <FormControl>
//             <FormLabel
//               sx={{
//                 fontSize: "16px",
//                 fontWeight: "bold",
//                 pb: "14px",
//                 color: teal[600],
//               }}
//               className="text-2xl font-semibold"
//               id="brand"
//             >
//               Brand
//             </FormLabel>
//             <RadioGroup
//               onChange={updateFilterParams}
//               aria-labelledby="brand"
//               defaultValue=""
//               name="brand"
//             >
//               {brands
//                 .slice(0, expendBrand ? brands.length : 5)
//                 .map((item, index) => (
//                   <FormControlLabel
//                     key={item.name}
//                     value={item.value}
//                     control={<Radio size="small" />}
//                     label={item.name}
//                   />
//                 ))}
//             </RadioGroup>
//           </FormControl>
//           <div>
//             <button
//               onClick={handleExpendBrand}
//               className="text-teal-600 cursor-pointer hover:text-teal-900 flex items-center"
//             >
//               {expendBrand ? "hide" : `+ ${brands.length - 5} more`}
//             </button>
//           </div>
//         </section>
//         <Divider /> */}

//           {/* Size */}
//           <section>
//           <FormControl>
//             <FormLabel
//               sx={{
//                 fontSize: "16px",
//                 fontWeight: "bold",
//                 pb: "14px",
//                 color: teal[600],
//               }}
//               className="text-2xl font-semibold"
//               id="size"
//             >
//               Size
//             </FormLabel>
//             <RadioGroup
//               name="size"
//               onChange={updateFilterParams}
//               aria-labelledby="size"
//               defaultValue=""
//             >
//               {size.map((item, index) => (
//                 <FormControlLabel
//                   key={item.name}
//                   value={item.value}
//                   control={<Radio size="small" />}
//                   label={item.name}
//                 />
//               ))}
//             </RadioGroup>
//           </FormControl>
//         </section>



//         {/* // Color */}
//         <section>
//           <FormControl sx={{ zIndex: 0 }}>
//             <FormLabel
//               sx={{
//                 fontSize: "16px",
//                 fontWeight: "bold",
//                 pb: "14px",
//                 color: teal[600],
//               }}
//               className="text-2xl font-semibold"
//               id="color"
//             >
//               Color
//             </FormLabel>
//             <RadioGroup
//               onChange={updateFilterParams}
//               aria-labelledby="color"
//               defaultValue=""
//               name="color"
//             >
//               {colors
//                 .slice(0, expendColor ? colors.length : 5)
//                 .map((item, index) => (
//                   <FormControlLabel
//                     sx={{ fontSize: "12px" }}
//                     key={item.name}
//                     value={item.name}
//                     control={<Radio size="small" />}
//                     label={
//                       <div className="flex items-center gap-3">
//                         <p>{item.name}</p>
//                         <span
//                           style={{ backgroundColor: item.hex }}
//                           className={` h-5 w-5 rounded-full ${
//                             item.name === "White" ? "border" : "border"
//                           }`}
//                         ></span>
//                       </div>
//                     }
//                   />
//                 ))}
//             </RadioGroup>
//           </FormControl>
//           <div>
//             <button
//               onClick={handleExpendColor}
//               className="text-teal-600 cursor-pointer hover:text-teal-900 flex items-center"
//             >
//               {expendColor ? "hide" : `+ ${colors.length - 5} more`}
//             </button>
//           </div>
//         </section>
//         <Divider />

//         <section>
//           <FormControl>
//             <FormLabel
//               sx={{
//                 fontSize: "16px",
//                 fontWeight: "bold",
//                 pb: "14px",
//                 color: teal[600],
//               }}
//               className="text-2xl font-semibold"
//               id="price"
//             >
//               Price
//             </FormLabel>
//             <RadioGroup
//               name="price"
//               onChange={updateFilterParams}
//               aria-labelledby="price"
//               defaultValue=""
//             >
//               {price.map((item, index) => (
//                 <FormControlLabel
//                   key={item.name}
//                   value={item.value}
//                   control={<Radio size="small" />}
//                   label={item.name}
//                 />
//               ))}
//             </RadioGroup>
//           </FormControl>
//         </section>
//         <Divider />
//         <section>
//           <FormControl>
//             <FormLabel
//               sx={{
//                 fontSize: "16px",
//                 fontWeight: "bold",
//                 pb: "14px",
//                 color: teal[600],
//               }}
//               className="text-2xl font-semibold"
//               id="brand"
//             >
//               Discount
//             </FormLabel>
//             <RadioGroup
//               name="discount"
//               onChange={updateFilterParams}
//               aria-labelledby="brand"
//               defaultValue=""
//             >
//               {discount.map((item, index) => (
//                 <FormControlLabel
//                   key={item.name}
//                   value={item.value}
//                   control={<Radio size="small" />}
//                   label={item.name}
//                 />
//               ))}
//             </RadioGroup>
//           </FormControl>
//         </section>
//       </div>
//     </div>
//   );
// };

// export default FilterSection;

// Changes for Modern website

import {
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Slider,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { brands } from "../../../data/Filter/brand";
import { teal } from "@mui/material/colors";
import { size } from "../../../data/Filter/size";
import { colors } from "../../../data/Filter/color";
import { discount } from "../../../data/Filter/discount";
import { useSearchParams } from "react-router-dom";

const MIN_PRICE = 0;
const MAX_PRICE = 1000;

const FilterSection = () => {
  const [expendColor, setExpendColor] = useState(false);
  const [expendBrand, setExpendBrand] = useState(false);
  const [expendSize, setExpendSize] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();

  const selectedSize = searchParams.get("size") || "";
  const selectedColor = searchParams.get("color") || "";
  const selectedDiscount = searchParams.get("discount") || "";

  const minPriceFromUrl = Number(searchParams.get("minPrice") || MIN_PRICE);
  const maxPriceFromUrl = Number(searchParams.get("maxPrice") || MAX_PRICE);

  const [priceRange, setPriceRange] = useState<number[]>([
    minPriceFromUrl,
    maxPriceFromUrl,
  ]);

  useEffect(() => {
    setPriceRange([minPriceFromUrl, maxPriceFromUrl]);
  }, [minPriceFromUrl, maxPriceFromUrl]);

  const handleExpendBrand = () => {
    setExpendBrand(!expendBrand);
  };

  const handleExpendColor = () => {
    setExpendColor(!expendColor);
  };

  const handleExpendSize = () => {
    setExpendSize(!expendSize);
  };

  const updateFilterParams = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    const params = new URLSearchParams(searchParams);

    if (value) {
      params.set(name, value);
    } else {
      params.delete(name);
    }

    params.set("page", "1");
    setSearchParams(params);
  };

  const clearAllFilters = () => {
    setSearchParams({});
    setPriceRange([MIN_PRICE, MAX_PRICE]);
  };

  const handlePriceChange = (_: Event, newValue: number | number[]) => {
    const updatedRange = newValue as number[];
    setPriceRange(updatedRange);

    const params = new URLSearchParams(searchParams);
    params.set("minPrice", String(updatedRange[0]));
    params.set("maxPrice", String(updatedRange[1]));
    params.set("page", "1");
    setSearchParams(params);
  };

  const handleColorSelect = (colorName: string) => {
    const params = new URLSearchParams(searchParams);

    if (selectedColor === colorName) {
      params.delete("color");
    } else {
      params.set("color", colorName);
    }

    params.set("page", "1");
    setSearchParams(params);
  };

  return (
    <div className="relative z-0 space-y-5 bg-white">
      <div className="flex items-center justify-between min-h-[44px] px-4 sm:px-6 lg:px-9 lg:border-r">
        <p className="text-lg font-semibold">Filters</p>
        <Button
          onClick={clearAllFilters}
          size="small"
          className="text-teal-600 cursor-pointer font-semibold"
        >
          clear all
        </Button>
      </div>

      <Divider />

      <div className="px-4 sm:px-6 lg:px-9 space-y-6">
        {/* Price Slider */}
        <section>
          <FormControl fullWidth>
            <FormLabel
              sx={{
                fontSize: "16px",
                fontWeight: "bold",
                pb: "14px",
                color: teal[600],
              }}
              className="text-2xl font-semibold"
              id="price"
            >
              Price
            </FormLabel>

            <div className="px-2">
              <Slider
                value={priceRange}
                onChange={handlePriceChange}
                valueLabelDisplay="auto"
                min={MIN_PRICE}
                max={MAX_PRICE}
                step={50}
                sx={{
                  color: "#061126",
                  "& .MuiSlider-thumb": {
                    width: 18,
                    height: 18,
                  },
                }}
              />

              <div className="flex items-center justify-between mt-2 text-sm text-slate-700">
                <span>₹ {priceRange[0]}</span>
                <span>₹ {priceRange[1]}</span>
              </div>
            </div>
          </FormControl>
        </section>

        <Divider />

        {/* Size */}
        <section>
          <FormControl>
            <FormLabel
              sx={{
                fontSize: "16px",
                fontWeight: "bold",
                pb: "14px",
                color: teal[600],
              }}
              className="text-2xl font-semibold"
              id="size"
            >
              Size
            </FormLabel>
            <RadioGroup
              name="size"
              onChange={updateFilterParams}
              aria-labelledby="size"
              value={selectedSize}
            >
              {size.map((item) => (
                <FormControlLabel
                  key={item.name}
                  value={item.value}
                  control={<Radio size="small" />}
                  label={item.name}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </section>

        <Divider />

        {/* Color */}
        <section>
          <FormControl fullWidth sx={{ zIndex: 0 }}>
            <FormLabel
              sx={{
                fontSize: "16px",
                fontWeight: "bold",
                pb: "14px",
                color: teal[600],
              }}
              className="text-2xl font-semibold"
              id="color"
            >
              Color
            </FormLabel>

            <div className="flex flex-wrap gap-3">
              {colors
                .slice(0, expendColor ? colors.length : 8)
                .map((item) => {
                  const isSelected = selectedColor === item.name;
                  return (
                    <button
                      key={item.name}
                      type="button"
                      onClick={() => handleColorSelect(item.name)}
                      title={item.name}
                      className={`h-8 w-8 rounded-[6px] border-2 transition-all ${
                        isSelected
                          ? "border-[#061126] scale-110 shadow-md"
                          : "border-slate-300 hover:border-slate-500"
                      }`}
                      style={{
                        background: item.gradient ? item.gradient : item.hex,
                      }}
                    />
                  );
                })}
            </div>
          </FormControl>

          <div className="mt-3">
            <button
              onClick={handleExpendColor}
              className="text-teal-600 cursor-pointer hover:text-teal-900 flex items-center"
            >
              {expendColor ? "hide" : `+ ${colors.length - 8} more`}
            </button>
          </div>
        </section>

        <Divider />

        {/* Discount */}
        <section>
          <FormControl>
            <FormLabel
              sx={{
                fontSize: "16px",
                fontWeight: "bold",
                pb: "14px",
                color: teal[600],
              }}
              className="text-2xl font-semibold"
              id="discount"
            >
              Discount
            </FormLabel>
            <RadioGroup
              name="discount"
              onChange={updateFilterParams}
              aria-labelledby="discount"
              value={selectedDiscount}
            >
              {discount.map((item) => (
                <FormControlLabel
                  key={item.name}
                  value={item.value}
                  control={<Radio size="small" />}
                  label={item.name}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </section>
      </div>
    </div>
  );
};

export default FilterSection;